import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fluidValues } from '@/css/resources/mixins.css';

const getStyles = () =>
	css(
		fluidValues('gridColumnGap', 15, 20),
		fluidValues('gridRowGap', 15, 20),
		{
			marginTop: '40px',

			'.supt-headerListAnchor__list': cssObj(
				fluidValues('gridColumnGap', 15, 20),
				fluidValues('gridRowGap', 15, 20),
				{
					display: 'flex',
					alignItems: 'center',
					flexWrap: 'wrap',
				}
			),

			'.supt-buttonPrimary, .supt-buttonSecondary': {
				margin: 0,

				'.supt-button__inner': {
					span: {
						whiteSpace: 'nowrap',
					},
				},
			},
		}
	);

// edit
const getEditGlobalStyles = () =>
	cssObj({
		'.wp-block[data-type="supt/header-list-anchor"]': cssObj({
			'.supt-listCards': {
				margin: 0,

				'[data-type="supt/button-secondary"]': {
					margin: 0,

					'> div': {
						margin: 0,
					},
				},
			},
		}),
	});

export { getStyles, getEditGlobalStyles };
